/**
 * Delivery Suburbs — region filter.
 * Loaded only when the section renders its region filter (see section-assets-once).
 * Single delegated listener per section instance; no global listeners, no observers.
 */
(function () {
  'use strict';

  if (customElements.get('delivery-suburbs-section')) return;

  class DeliverySuburbsSection extends HTMLElement {
    connectedCallback() {
      this._filter = this.querySelector('[data-suburb-filter]');
      if (!this._filter) return;

      this._items = Array.from(this.querySelectorAll('.delivery-suburbs__item'));
      this._empty = this.querySelector('[data-suburb-empty]');
      this._onClick = this._onClick.bind(this);
      this._filter.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this._filter?.removeEventListener('click', this._onClick);
    }

    _onClick(event) {
      const button = event.target.closest('[data-region-filter]');
      if (!button || !this._filter.contains(button)) return;

      this._apply(button.dataset.regionFilter || '');

      this._filter.querySelectorAll('[data-region-filter]').forEach((btn) => {
        btn.setAttribute('aria-pressed', String(btn === button));
      });
    }

    _apply(region) {
      let visible = 0;

      this._items.forEach((item) => {
        const matches = region === '' || item.dataset.region === region;
        item.hidden = !matches;
        if (matches) visible += 1;
      });

      if (this._empty) this._empty.hidden = visible > 0;
    }
  }

  customElements.define('delivery-suburbs-section', DeliverySuburbsSection);
})();
